<template>
  <div class="novel-template flex flex-column">
    <slot name="header" />
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      expandSideMenu: true,
    };
  },
  methods: {
    toggleExpand() {
      this.expandSideMenu = !this.expandSideMenu;
    },
  },
});
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.root {
  display: flex;
  height: 90%;
}

.side-menu.shrink {
  display: flex;
  flex-direction: column;
  width: 50px;
  transition: all 0.3s ease;
}

.side-menu.expand {
  transition: all 0.3s ease;
  width: 200px;
}

main {
  flex-grow: 2;
  height: 100%;
}

.btn-expand {
  margin-left: 0;
}
</style>
